// #region Imports
import React, { useState, useEffect } from 'react';
import './HistoricoVendasTable.scss';
import { formatCurrency, formatDate } from '../../../../shared/helpers';
// #endregion

export default function HistoricoVendasTable({ vendas = [], loading = false, filters, onFiltersChange }) {
  // #region Estado
  const [local, setLocal] = useState(filters);
  useEffect(() => { setLocal(filters); }, [filters]);
  // #endregion

  // #region Handlers
  function update(patch) {
    const next = { ...local, ...patch };
    setLocal(next);
    onFiltersChange(next);
  }
  // #endregion

  // #region Helpers render
  const renderBody = () => {
    if (loading) {
      return Array.from({ length: 3 }).map((_, i) => (
        <tr key={i} className="sk-row">
          <td colSpan="7">Carregando...</td>
        </tr>
      ));
    }
    if (!vendas.length) {
      return (
        <tr>
          <td colSpan="7" className="empty">Nenhuma venda</td>
        </tr>
      );
    }
    return vendas.map(v => (
      <tr key={v.id}>
        <td>#{v.id}</td>
        <td>{formatDate(v.data_hora)}</td>
        <td>{v.cliente_id || '-'}</td>
        <td>{v.funcionario_id || '-'}</td>
        <td>{formatCurrency(v.valor_total)}</td>
        <td>
          <span className={`tag ${v.status === 'FINALIZADA' ? 'tag-success-outline' : 'tag-warning-outline'}`}>
            {v.status === 'FINALIZADA' ? 'Finalizada' : 'Pendente'}
          </span>
        </td>
        <td>{v.is_fiado ? 'Sim' : 'Não'}</td>
      </tr>
    ));
  };
  // #endregion

  // #region Render
  return (
    <div className="historico-wrapper">
      <div className="filters-bar">
        <input
          placeholder="Buscar por cliente, funcionário ou ID..."
          value={local.q}
          onChange={e => update({ q: e.target.value })}
        />
        <select
          value={local.status}
          onChange={e => update({ status: e.target.value })}
        >
          <option value="TODOS">Todos</option>
          <option value="FINALIZADA">Finalizadas</option>
          <option value="PENDENTE">Pendentes</option>
        </select>
      </div>
      <div className="table-container">
        <table className="ct-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Data/Hora</th>
              <th>Cliente</th>
              <th>Funcionário</th>
              <th>Valor</th>
              <th>Status</th>
              <th>Fiado</th>
            </tr>
          </thead>
          <tbody>{renderBody()}</tbody>
        </table>
      </div>
    </div>
  );
  // #endregion
}
